// extracted by mini-css-extract-plugin
export default {"container":"FeasibilityCheckerPage_container__VyrwG","title":"FeasibilityCheckerPage_title__lgxBt"};